import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHttp } from '@app/hooks';
import { NavMenu, NavMenuButton } from 'cat-ecommerce-alloy';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';
import {
  COMMON_SET_TOAST_INFO,
  COMMON_SET_TOAST_TYPE
} from '@app/store/common/constants';
import { TOAST_TYPE } from '@app/constants/commonConstants';
import { PCC_PS_TITLE_UPDATES } from '@app/constants/featureFlags';

const HeaderActionsItems = ({ optionList }) => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const { storeId, langId, catalogId } = useSelector(state => state.common);
  const titleUpdatesFlagEnabled = useSelector(
    state => state?.featureFlag?.[PCC_PS_TITLE_UPDATES]
  );
  const { invoke, data, responseHeaders } = useHttp();

  const buildName = responseHeaders => {
    const contentDisposition = responseHeaders['content-disposition'];
    const startNameSection = contentDisposition.indexOf('"') + 1;
    const endNameSection = contentDisposition.lastIndexOf('"');
    const fileNameAndType = contentDisposition.substring(
      startNameSection,
      endNameSection
    );
    return {
      fileName: fileNameAndType.substring(0, fileNameAndType.lastIndexOf('.')),
      fileType: fileNameAndType.substring(fileNameAndType.lastIndexOf('.') + 1)
    };
  };

  const openLink = (link, fileName, fileType) => {
    link.download = `${fileName}.${fileType}`;
    link.click();
    link.remove();
  };

  useEffect(() => {
    if (data && responseHeaders) {
      const link = document.createElement('a');
      const blob = new Blob([data], {
        type: data?.type || 'application/octet-stream'
      });

      link.href = window.URL.createObjectURL(blob);

      const { fileName, fileType } = buildName(responseHeaders);
      openLink(link, fileName, fileType);
    }
  }, [data, responseHeaders]);

  const downloadFile = async url => {
    try {
      await invoke({
        url,
        method: 'get',
        rethrowError: true,
        skipRedirectOnError: true,
        responseType: 'blob'
      });
    } catch (error) {
      if (error.response && error.response.status !== 403) {
        document.location.href =
          'ProhibitedCharacterErrorView?storeId=' +
          storeId +
          '&catalogId=' +
          catalogId +
          '&langId=' +
          langId;
      } else {
        dispatch({ type: COMMON_SET_TOAST_TYPE, payload: TOAST_TYPE.FAIL });
        dispatch({
          type: COMMON_SET_TOAST_INFO,
          payload: t('DOWNLOAD_FAILED')
        });
      }
    }
  };

  return (
    <NavMenu>
      {optionList?.map(({ url, displayName }) => (
        <NavMenuButton
          key={url}
          linkClassName={cx(
            { 'text-capitalize': titleUpdatesFlagEnabled },
            'pe-5 py-2 text-uppercase'
          )}
          className="mb-0"
          onClick={() => downloadFile(url)}
          rel="noopener noreferrer"
        >
          {t(displayName)}
        </NavMenuButton>
      ))}
    </NavMenu>
  );
};

HeaderActionsItems.propTypes = {
  optionList: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired
    })
  )
};

export default HeaderActionsItems;
